@if (state() === "loading") {
  <app-loading />
}

@if (state() === "error") {
  <app-error-data title="Something went wrong" [showRetry]="true" (retry)="pageChange.emit(currentPage())" />
}

@if (state() === "success") {
  <app-tables
    [scopeResolver]="getScopeForAction"
    [headerItems]="tableHeaderData()"
    [rows]="rows()"
    (toggleDropdown)="toggleDropdown($event)"
    [currentActions]="currentActions()"
    (actionTrigger)="handleAction($any($event))"
    [isFiltersApplied]="isFiltersApplied()"
    [emptyFilterTitle]="isArabic() ? 'لا توجد خطوط سير تطابق الفلترة' : 'No routes match your criteria.'"
    [emptyContentTitle]="isArabic() ? 'لا توجد خطوط سير' : 'No Routes Found'"
    [emptyContentDescription]="isArabic() ? 'لم تقم بإنشاء أي خطوط سير بعد.' : 'No routes have been created yet.'" />

  <app-pagination
    [itemsPerPage]="itemsPerPage()"
    [currentPage]="currentPage()"
    [getPageNumbers]="pageNumbers()"
    [totalPages]="totalPages()"
    [startItem]="startItem()"
    [endItem]="endItem()"
    [totalItems]="totalItems()"
    (previousPage)="onPreviousPage()"
    (nextPage)="onNextPage()"
    (goToPage)="onGoToPage($event)"
    (changePageNumber)="onChangePageNumber($event)"
    (pageSizeChange)="onPageSizeChange()" />
}
